import { z } from 'zod';

// Case workflow features of the case page (PPL-3027):
// - mdtFeedback: the MDT feedback form section
// - canDischarge: manual case discharge (discharge button, estimated
//   discharge date picker, the Discharge stage of the case progress bar) —
//   `can*` = manual-action availability, mirroring referralPausing.canPause
// - rtwSeForms: the "RTW SE" self-efficacy forms section of the case page
// - rtwOutcomeTracking: the improved-concern / returned-to-work outcome
//   questions on the case page. Wherever the questions are shown they must
//   also be ANSWERED before manual discharge (PPL-2776) — displayed implies
//   required, there is no separate flag.
// - appointmentConclusions: the "Conclusion" column of the appointments
//   table
// (the three were one `outcomeTracking` flag until PPL-2776 split them —
// they are separate features, not one bundle)
// A present doc fully defines the group: all fields are required.
export const CaseWorkflowsSettingsSchema = z.strictObject({
  mdtFeedback: z.boolean(),
  canDischarge: z.boolean(),
  rtwSeForms: z.boolean(),
  rtwOutcomeTracking: z.boolean(),
  appointmentConclusions: z.boolean(),
});

export type CaseWorkflowsSettings = z.infer<typeof CaseWorkflowsSettingsSchema>;
